import { CommonConfig, ProjectConfig } from '../app/helpers/config';
import { PageType } from '../app/helpers/page';

const lightGalleryWrapper = 'lightgallery-wrapper';

export const commonConfig: CommonConfig = {
    accountApi: `api/accounts/accounts/`,
    activeHeadingArea: 400,
    adminPath: `admin/`,
    apiUrl: 'https://docs-api.kaptioapis.com/',
    authPath: `auth/login/google-oauth2/?next=%2Faccounts%2Fredirect-after-login%2F`,
    authStorage: 'auth',
    authUrlParam: 'token',
    bodyTouchClass: 'kd-touch',
    codeSnippetPrefix: /^\[syntax:([^\]]+)\]/,
    codeSnippetSyntaxMatch: 1,
    credentialsApi: `api/accounts/credentials/`,
    debounceInput: 500,
    docsApi: `api/docs/`,
    headlineSelectors: new Map<PageType, string>([
        [PageType.Quip, '.sheet kd-document h2'],
        [PageType.Versioned, '.sheet kd-document h2'],
        [PageType.ReleaseType, '.sheet kd-document h2'],
        [PageType.ReleaseNotes, '.sheet kd-release-notes .slds-tabs_default__content.slds-show kd-document h1'],
    ]),
    lightGalleryConfig: {
        selector: `.${lightGalleryWrapper}`,
        zoom: true,
    },
    lightGalleryWrapper,
    referrerHelpUrl: 'https://en.wikipedia.org/wiki/HTTP_referer',
    requestSnippetPrefix: /^\[format:json\]/,
    scrollContainer: '.scroll-container',
    searchLimit: 20,
    searchQueryMin: 3,
    sldsConfig: {
        svgPath: 'slds/icons/'
    },
    snippetBackdropDelay: 100,
    snippetCredentialClass: 'kd-document-credential',
    snippetCredentialTemplateId: 'snippetCredentialTemplate',
    snippetCredentialTooltips: {
        added: 'We have added your individual credentials for your convenience, be careful when sharing this snippet',
        authorized: 'Add your personal credentials to get interactive code snippets',
        unauthorized: 'Login with your G Suite or Google Account to get interactive code snippets'
    },
    snippetIndentation: '    ',
    snippetLangStorage: 'snippetLang',
    throttleInterface: 100,
    visibilityMessage: new Map([
        [true, 'Make this document publicly available.'],
        [false, 'Make this document internally available only.'],
    ]),
};

export const docsConfig: ProjectConfig = {
    label: 'Technical Documentation',
    platformId: 'developer-docs',
    searchCategories: true,
    title: 'Kaptio Technical Documentation',
    useExpandedNavigation: false,
};

export const releaseNotesConfig: ProjectConfig = {
    label: 'Release Notes',
    platformId: 'release-notes',
    searchCategories: false,
    title: 'Kaptio Release Notes',
    useExpandedNavigation: true,
};
